import {DrupalLink} from 'src/Utils';

export default function InvestWithAjBell() {

    const buttonStyle = "c-btn button-default waves-effect waves-light button c-btn-small full-width";
    
    return <div className="card text-align-center white-bg margin-0">
        <ul className="card-content padding-left-10 padding-right-10">
            <li style={{listStyle: "none"}}>
                <span className="caption inline-block padding-bottom-20">Invest with AJ Bell</span>
            </li>
            <li className="margin-bottom-10">
                <DrupalLink id="sidebar-open-an-account-ifc" action={`/open-an-account`} className={`${buttonStyle} button--red`}>Open an account</DrupalLink>
            </li>
            <li>
                <DrupalLink id="sidebar-transfer-an-ifc" action={`/transferring-to-us`} className={`${buttonStyle} button--darkblue`}>Transfer now</DrupalLink>
            </li>
        </ul>
        <ul className="card-action center-align">
            <li style={{listStyle: "none"}}>
                <span className="caption padding-bottom-10">Have a question?<br/><span className="font-weight-normal">Open from 8am to 7pm Monday to Friday</span></span>
                <span className="h7 block">Call customer services<br/><strong>0345 54 32 600</strong></span>
            </li>
        </ul>
    </div>
}